import timezones from 'timezones-list';
import extraTimezones from "./extraTimezones";
export const TIMEZONES = [...timezones, ...extraTimezones];
export const TIMEZONE_OPTIONS = TIMEZONES.map(tz => ({
  label: tz.label,
  value: tz.tzCode
}));
export const REGIONS = [{
  label: 'Asia',
  value: 'Asia'
}, {
  label: 'Africa',
  value: 'Africa'
}, {
  label: 'America',
  value: 'America'
}, {
  label: 'Antarctica',
  value: 'Antarctica'
}, {
  label: 'Atlantic',
  value: 'Atlantic'
}, {
  label: 'Australia',
  value: 'Australia'
}, {
  label: 'Europe',
  value: 'Europe'
}, {
  label: 'Indian',
  value: 'Indian'
}, {
  label: 'Pacific',
  value: 'Pacific'
}];
export const HOURS_OF_OPERATION_OPTIONS = [{
  name: 'hours',
  value: '24hours',
  label: '24 hrs / day'
}, {
  name: 'hours',
  value: 'custom',
  label: 'Custom hours'
}];
export const DAYS_OF_OPERATION_OPTIONS = [{
  name: 'days',
  value: '7days',
  label: '7 days / week'
}, {
  name: 'days',
  value: 'custom',
  label: 'Custom days'
}];